import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Button, Divider, Form, Input, Message, Image, Item, Container, Search, Popup, Header, TextArea, Modal, Loader } from 'semantic-ui-react'
import smoothscroll from 'smoothscroll-polyfill'
import Folder from './folder'
import { backendService } from '../../services/backendService'
import _ from 'lodash'
import Logo from '../../images/logo-admin.png'
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { NotificationManager } from 'react-notifications';

class Projects extends React.Component {

  constructor() {
    super()
    smoothscroll.polyfill();
    this.getProjects = this.getProjects.bind(this)
    this.deleteFolder = this.deleteFolder.bind(this)
    this.updateFolder = this.updateFolder.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmitFolder = this.handleSubmitFolder.bind(this)
    this.state = {
      projects: [],      
      selectedFolder: '',
      modalOpen: false,      
      isPopupFoldersOpen: false,      
      value: '',
      errorAreaFolder: true,
      isSearchLoading: false,
      searchedElements: [],     
      caso: '',
      bookmarkText: '',
      processing: false
    }
  }

  componentDidMount() {

    window.dataLayer.push({
      event: 'page_view',
      page: {
        url: document.location.pathname,
        title: 'User Projects'
      }
    });

    this.getProjects()
  } 

  handleSearchChange = (e, { value }) => {
    this.setState({ isSearchLoading: true, value: value })

    setTimeout(() => {
      if (this.state.value.length < 1) return this.setState({
        isPopupFoldersOpen: false,        
        selectedFolder: '',
        value: '',
        errorAreaFolder: true,
        isSearchLoading: false,
        searchedElements: this.state.projects,
        caso: '',
        bookmarkText: ''
      })

      const re = new RegExp(_.escapeRegExp(this.state.value), 'i')
      const isMatch = result => re.test(result.name)

      this.setState({
        isSearchLoading: false,
        searchedElements: _.filter(this.state.projects, isMatch),
      })
    }, 300)
  }

  async getProjects() {
    this.setState({ processing: true })
    try {
      const response = await backendService.get(`/api/projects?user=${this.props.auth.user.email}`)
      this.setState({ processing: false })
      if (response.data) {
        this.setState({ projects: response.data, searchedElements: response.data })
      } else {
        NotificationManager.error(Translate(this.context, 'generic_fail_message'))
      }
    } catch (exc) {
      NotificationManager.error(Translate(this.context, 'generic_fail_message'))
      this.setState({ processing: false })
    }
  }

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value })

    if (value !== '') {
      if (name === 'bookmarkText' && this.state.caso !== '') {
        this.setState({errorAreaFolder: false})
      } else if (name === 'caso' && this.state.bookmarkText !== '') {
        this.setState({errorAreaFolder: false})
      }
    } else {
      this.setState({errorAreaFolder: true})
    }
  }


  async handleSubmitFolder() {
    this.setState({ processing: true })
    if (this.state.bookmarkText !== '' && this.state.caso !== '') {
      const response = await backendService.post('/api/projects', { user: this.props.auth.user.email, name: this.state.caso, description: this.state.bookmarkText })
      if (response.data.success === false) {        
        this.setState({ processing: false }) 
        NotificationManager.error(Translate(this.context, 'folder_name_exists'))               
      } else {
        this.setState({ selectedFolder: this.state.caso, 
                        isPopupFoldersOpen: false, 
                        errorAreaFolder: true, 
                        bookmarkText: '', 
                        caso: '' 
                      })
        NotificationManager.success(Translate(this.context, 'folder') + " " + this.state.selectedFolder + " " + Translate(this.context, 'folder_created'))
        this.getProjects()
      }
    }    
  }

  handleOpenFoldersPopup = () => this.setState({ isPopupFoldersOpen: true })

  handleCloseFoldersPopup = () => this.setState({ isPopupFoldersOpen: false })

  async deleteFolder(project_id) {
    this.setState({ processing: true })
    try {
      const response = await backendService.delete(`/api/projects/${project_id}`)
      if (response.data.success) {
        setTimeout(() => {
          window.scrollTo(0, 0);
        });
        this.setState({ selectedFolder: project_id})
        this.getProjects()
        NotificationManager.success(Translate(this.context, 'folder') +  " " + Translate(this.context, 'folder_deleted'))
      } else {
        NotificationManager.error(Translate(this.context, 'generic_fail_message'))
        this.setState({ processing: false })
      }
    } catch (exc) {
      this.setState({ processing: false })
      NotificationManager.error(Translate(this.context, 'generic_fail_message'))
    }
    
  }

  async updateFolder(project_id, folder, description) {
    this.setState({ processing: true })
    const project = {
      name: folder,
      description: description,
      user: this.props.auth.user.email
    }
    try {
      const response = await backendService.put('/api/projects/' + project_id, { project: project })

      if (response.data && response.data.success) {
        this.setState({ selectedFolder: folder })
        NotificationManager.success(Translate(this.context, 'folder_description') + " " + this.state.selectedFolder + " " + Translate(this.context, 'folder_description_modified'))
        this.getProjects()
      } else if (response.data && response.data.success == false) {
        this.setState({ processing: false })
        NotificationManager.error(Translate(this.context, 'folder_name_exists'))
      } else {
        this.setState({ processing: false })        
        NotificationManager.error(Translate(this.context, 'generic_fail_message'))
      }
    } catch (exc) {
      this.setState({ processing: false })
      NotificationManager.error(Translate(this.context, 'generic_fail_message'))
    }
  }

  render() {
    
    const isSearchLoading = this.state.isSearchLoading
    const isProcessing = this.state.processing
    const value = this.state.value
    const caso = this.state.caso
    const bookmarkText = this.state.bookmarkText

    return (
      <Row>
        <Col xs={8} sm={4} md={3} className='lisia-app-logo-wrapper'>
          <Link to='/'>
            <Image src={ Logo } />
          </Link>
        </Col>           
        <Col className="lisia-app-card-content projects centered" xs={12} md={10}>
          <div className='lisia-app-header'>
            <div className='header'>
              <Link to='/'>
                <Text tid="back" />
              </Link>            
            </div>          
            <h3 className='text-center lisia-app-card-title'><Text tid="folders_title" /></h3>
          </div>
          <Divider />
          {this.state.projects.length === 0 &&
            <Popup
              content={<div>
                <Header as='h5'><Text tid="folders_create_new_folder" /></Header>
                <Form onSubmit={this.handleSubmitFolder}>
                  <Input fluid name='caso' value={caso} onChange={this.handleChange} placeholder={Translate(this.context, 'folder_name')} />
                  <TextArea name='bookmarkText' value={bookmarkText} onChange={this.handleChange} placeholder={Translate(this.context, 'folders_description')} />
                  <Button className='buttonsFolders lisia-blue' type='submit' style={{width: '100%'}} disabled={this.state.errorAreaFolder}><Text tid="save" /></Button>
                </Form>
              </div>}
              on='click'
              open={this.state.isPopupFoldersOpen}
              onOpen={this.handleOpenFoldersPopup}
              onClose={this.handleCloseFoldersPopup}
              trigger={<Button basic className='highlightsButtons'  size='large' icon='plus' />}
            />}
          {this.state.projects.length > 0 &&
            <div>
              <Search
                className='searchFolders'
                value={value}
                showNoResults={false}
                placeholder={Translate(this.context,'folders_search')}
                onSearchChange={_.debounce(this.handleSearchChange, 500, {
                  leading: true,
                })} />
              <Popup
                content={<div>
                  <Header as='h5'><Text tid="folders_create_new_folder" /></Header>
                  <Form onSubmit={this.handleSubmitFolder}>
                    <Input fluid name='caso' value={caso} onChange={this.handleChange} placeholder={Translate(this.context, 'folder_name')} />
                    <TextArea name='bookmarkText' value={bookmarkText} onChange={this.handleChange} placeholder={Translate(this.context, 'folders_description')} />
                    <Button className='buttonsFolders lisia-blue' style={{width: '100%'}} type='submit' disabled={this.state.errorAreaFolder}><Text tid="save" /></Button>
                  </Form>
                </div>}
                on='click'
                open={this.state.isPopupFoldersOpen}
                onOpen={this.handleOpenFoldersPopup}
                onClose={this.handleCloseFoldersPopup}
                trigger={<Button basic className='highlightsButtons addFolderBtn' size='large' icon='plus' />}
              />
              { isSearchLoading || isProcessing ?
                <Loader active inline='centered' className='marginLoadMore' />
              : 
                <Item.Group link divided>
                  {this.state.searchedElements.sort(function (a, b) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    return 0;
                  }).map((project, i) => {
                    return (
                      <Folder
                        key={'project' + i}
                        project={project}
                        deleteFolder={this.deleteFolder}
                        updateFolder={this.updateFolder}
                      />
                    )
                  })
                  }
                </Item.Group>
              }
              <Divider />
            </div>}
        </Col>
      </Row>
    )
  }
}

Projects.propTypes = {
  projects: PropTypes.object
}

const mapStateToProps = (state) => ({
  auth: state.auth,
})

Projects.contextType = LanguageContext;

export default connect(mapStateToProps)(Projects)